import React from 'react'
import '../CookiePolicy/CookiePolicy.css'
import Navbar from '../../Componect/Navbar/Navbar'
import FooterBottom from '../../Componect/Footer/FooterBottom'
function CookiePolicy() {
return (
    <>
    <div className='CookiePolicy'>
            <Navbar></Navbar>
            <div className='CookiePolicyTxt'>
                    <h1>Cookie Policy</h1>
                    <p>
                            At স তে সতেরো, we use cookies to enhance your browsing experience. This policy explains what cookies are, how we use them, and how you can manage them.
                    </p>
                    <h2>1. What Are Cookies?</h2>
                    <p>
                            Cookies are small text files stored on your device when you visit our website. They help us improve your experience by remembering your preferences and website activities.
                    </p>
                    <h2>2. How We Use Cookies</h2>
                    <p>We use cookies to:</p>
                    <ul>
                            <li>Enhance website functionality and user experience.</li>
                            <li>Analyze website traffic and improve our services.</li>
                            <li>Store your preferences for faster browsing.</li>
                            <li>Provide relevant offers and advertisements (if applicable).</li>
                    </ul>
                    <h2>3. Types of Cookies We Use</h2>
                    <ul>
                            <li>Essential Cookies: Necessary for website functionality.</li>
                            <li>Analytics Cookies: Help us understand visitor behavior.</li>
                            <li>Marketing Cookies: Used for personalized promotions (if applicable).</li>
                    </ul>
                    <h2>4. Managing Cookies</h2>
                    <p>
                            You can manage or disable cookies through your browser settings. However, disabling cookies may affect website performance and features.
                    </p>
                    <h2>5. Contact Us</h2>
                    <p>
                            If you have any questions about our Cookie Policy, feel free to contact us:
                    </p>
                    <ul>
                            <li>📧 Email: stesotero53@gmail.com</li>
                            <li>📞 Phone: 01780-126370</li>
                            <li>📍 Address: Sector-17, Block-I, Road-10, Plot-26, Uttara, Dhaka</li>
                    </ul>
                    <p>
                            By continuing to use our website, you consent to our use of cookies.
                    </p>
            </div>
            <FooterBottom></FooterBottom>
    </div>
    </>
)
}

export default CookiePolicy